import React from 'react';
import {
	Card,
	CardContent,
	Box,
	Divider as MuiDivider,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	Typography,
	Icon as MuiIcon,
	Tooltip,
	Avatar,
	Chip as MuiChip,
	CardHeader
} from '@mui/material';
import { spacing } from "@mui/system";
import { styled } from "@mui/styles";
import { grey } from "@mui/material/colors";
import avatarStyles from "../theme/avatars";
import _ from 'lodash';

import {
	Phone,
	Email,
	Description,
	Create,
	Help,
	Person,
	PermPhoneMsg
} from '@mui/icons-material';

const Divider = styled(MuiDivider)(spacing);

const Icon = styled(MuiIcon)({
	color: grey[700]
});

const Chip = styled(MuiChip)(({ theme }) => ({
	height: '20px',
	padding: '4px 0',
	fontSize: '85%',
	backgroundColor: theme.palette.secondary.main,
	color: theme.palette.common.white,
	'& span': {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
	}
}));

const activityMap = {
	"Email": {
		label: "Emails",
		icon: <Email />
	},
	"Note": {
		label: "Call Notes",
		icon: <PermPhoneMsg />
	},
	"InternalNote": {
		label: "Internal Notes",
		icon: <Create />
	},
	"Call": {
		label: "Calls",
		icon: <Phone />
	},
	"Misc": {
		label: "Misc Activities",
		icon: <Help />
	},
	"Document": {
		label: "Documents",
		icon: <Description />
	},
	"Adviser": {
		label: "Adviser Activities",
		icon: <Person />
	}
}

const UserStatsCard = ({
	u,
	activities,
	totalActivities,
	totalActivityMinutes,
	isDashboard,
	fromDate,
	toDate
}) => {
	const avatarClasses = avatarStyles();

	return (
		<Card>
			{isDashboard && <CardHeader
				action={
					<Chip label={!(toDate && fromDate) ? "Last week" : "Custom date range"} />
				}
			/>}
			<CardContent>
				<Box display="flex" flexDirection="column" alignItems="center" mt={3} mb={3} ml={6} mr={6}>
					<Avatar className={avatarClasses.xlarge} src={u.photo} alt={u.name} />
					<Typography variant="subtitle2">{u.position || ""}</Typography>
					<Typography variant="caption">{u.name}</Typography>
				</Box>
				<Divider my={6} />
				<Table>
					<TableHead>
						<TableRow>
							<TableCell></TableCell>
							<TableCell>Number</TableCell>
							<TableCell>Minutes</TableCell>
							<TableCell>Average</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{activities.map(a =>
							<TableRow key={a.activityType}>
								<TableCell><Tooltip title={activityMap[a.activityType].label}><Icon>{activityMap[a.activityType].icon}</Icon></Tooltip></TableCell>
								<TableCell>{a.totalActivities}</TableCell>
								<TableCell>{_.round(a.totalDuration / 60, 1)}</TableCell>
								<TableCell>{a.totalActivities === 0 ? 0 : _.round((a.totalDuration / 60) / a.totalActivities, 1)}</TableCell>
							</TableRow>
						)}
						<TableRow>
							<TableCell>Total</TableCell>
							<TableCell>{totalActivities}</TableCell>
							<TableCell>{_.round(totalActivityMinutes, 1)}</TableCell>
							<TableCell>{totalActivities === 0 ? 0 : _.round(totalActivityMinutes / totalActivities, 1)}</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</CardContent>
		</Card>
	);
}


export default UserStatsCard;